/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["min.","midi","mat.","ap.m.","soir","nuit"],u,["minuit","midi","du matin","de l’après-midi","du soir","du matin"]],[["min.","midi","mat.","ap.m.","soir","nuit"],u,["minuit","midi","matin","après-midi","soir","nuit"]],["00:00","12:00",["04:00","12:00"],["12:00","18:00"],["18:00","24:00"],["00:00","04:00"]]];
